import React, {useContext, useEffect, useState} from 'react';
import JobListViewContext, { RightClickContext } from '../common/JobListViewContext';
import { UTFaxLogListItem } from '../../fms.data/models/UTFaxLogListItem';

import { JobNames } from '../../framework.core/JobNames';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../ui/ActionButton';
import ToolboxMenuItem from '../../uiControls/ToolboxMenuItem';
import ListViewShortcutMenu from '../common/ListViewShortcutMenu';
import useFunctionKeys from '../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../uiControls/infoArea/InfoAreaDrawer';
import AbstractListView, { DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer, ListOrderBy, ListRowRenderer } from '../common/AbstractListView';
import { Search } from '../../filtering';
import constants from '../../constants';
import { DateRenderer, DateTimeRenderer, FloatRenderer, NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer } from '../../uiControls/SmartTableRenderers';
import { TableColumn, TableSettings, utFaxLogListItem } from '../../tableSettings';
import JobListSuntekCommand from '../common/JobListSuntekCommand';
import * as XCol from '../../framework.core/XExportColumn';
import Menu, { IfmsMenuItem } from '../../ui/menu/Menu';
import { DocumentType } from '../../framework.core/DocumentType';

/*
function useSelectedOperations() {
  // const jobListContext = useContext(JobListViewContext);
  // const appContext = useContext(ApplicationContext);
  // const history = useHistory();
  //const operation = 'accounting';

  // const selectedElement = jobListContext.selectedElement as UTFaxLogListItem;

  // const [showGlobalOkDialog] = useGlobalOkDialog();
  // const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  // async function create() {
  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPrepaidExpenseAdjustment/add`)) {
  //     await showGlobalOkDialog(<p>New operation is already in progress</p>);
  //     return;
  //   }

  //   openNewPage(history, `/${operation}/acPrepaidExpenseAdjustment/add`, NavigationType.newPage);
  // }

  // async function deleteEntity() {
  //   if (!selectedElement) {
  //     return;
  //   }
  
  //   const doDelete = await showGlobalYesNoDialog(
  //     <div>
  //       <h3>Confirm to Delete?</h3>
  //     </div>
  //   );

  //   if (doDelete) {
  //     const apiResult = await appContext.api.deleteJobDetail(JobNames.PrepaidExpenseAdjustment, {
  //       id: selectedElement.id,
  //       pimsLinkId: 0
  //     });
  //     if (apiResult && apiResult.success) {
  //       jobListContext.reloadData();
  //     } else {
  //       const message = apiResult?.message ?? 'Cannot delete!';
  //       await showGlobalOkDialog(message);
  //     }
  //   }
  // }

  // async function edit() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPrepaidExpenseAdjustment/edit`)) {
  //     await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
  //     return;
  //   }

  //   const id = selectedElement.id;
  //   openNewPage(history, `/${operation}/acPrepaidExpenseAdjustment/edit/${id}`, NavigationType.newPage);
  // }

  // async function view() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   const id = selectedElement.id;

  //   const viewUrl = `/${operation}/acPrepaidExpenseAdjustment/view/${id}`;

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(viewUrl)) {
  //     await showGlobalOkDialog(<p>View operation is already in progress</p>);
  //     return;
  //   }

  //   openNewPage(history, viewUrl, NavigationType.newPage);
  // }

  // async function copy() {
  //   if (!selectedElement) {
  //     return;
  //   }

  //   if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPrepaidExpenseAdjustment/add`)) {
  //     await showGlobalOkDialog(<p>New operation is already in progress</p>);
  //     return;
  //   }

  //   const id = selectedElement.id;
  //   openNewPage(history, `/${operation}/acPrepaidExpenseAdjustment/add?copyId=${id}`, NavigationType.newPage);
  // }

  return {};
}
*/

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  //const { create, deleteEntity, edit, view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  //const appContext = useContext(ApplicationContext);
  // const listSec = findSecurityTask(appContext, FmsSecTask.AcctPrepaidAdjustment);
  // const selectedElement = jobListContext.selectedElement as UTFaxLogListItem;

  const items = [
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Refresh', shortcut: 'F11', separator: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    index,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        jobListContext.triggerTableSearch('F5');
        break;
      case 1:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  return (
    // <div className="ifms-common-no-vertical-separator">
    //   <UniqueLinkButton display="primary" size="regular" link={''} disabled
    //                     label={<span><FontAwesomeIcon icon={faPlus}/>&nbsp; New</span>}/>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={ViewIcon}/>&nbsp; View</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={EditIcon}/>&nbsp; Edit</PrimaryButton>&nbsp;
    //   <PrimaryButton size="regular" disabled ><FontAwesomeIcon
    //     icon={DeleteIcon}/>&nbsp; Delete</PrimaryButton>&nbsp;
    // </div>
    <></>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  //const {create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F5") {
      jobListContext.triggerTableSearch('F5');
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F5', 'F11'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.LogFax}
      jobId={(jobListContext.selectedElement as UTFaxLogListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 *
 * @class FaxLogListView
 * @extends {AbstractListView}
 */
class FaxLogListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.LogFax,
      'UTFaxLogListItem',
      UTFaxLogListItem.calculateSearchParameters(search,UTFaxLogListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: UTFaxLogListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.LogFax, 'UTFaxLogListItem',
      UTFaxLogListItem.calculateSearchParameters(search, UTFaxLogListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  UTFaxLogListItem.formatData(apiResult.entities);
  }

  

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return UTFaxLogListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.type === XCol.XCellType.Double) colRenderer.Cell = (props:any) => <FloatRenderer {...props} decimals={2} />;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'postDate',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  utFaxLogListItem;
    const cols = UTFaxLogListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  
  hasMemo(): boolean {
    return false;
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: UTFaxLogListItem) {
    return '';
  }

  getOpenUrlFor(row: UTFaxLogListItem) {
    function sanitizeFileName(fileName: string) {
      return fileName
        ?.replaceAll(/\:/g, '-')                // 윈도우 파일시스템 제한 문자
        ?.replaceAll(/[/\\?%*|"<>+]/g, ' ')     // 윈도우 파일시스템 제한 문자 && 업로드 파일 URL 호출 시 특수문자가 포함되어 있을 경우 에러가 발생함("+" 문자 추가)
        ?.replaceAll(/\./g, ' ')                // 마침표를 공백으로            ???
        ?.replaceAll(/\#/g, ' ')                // #을 공백으로                ???
        ?.replaceAll(/\s+/g, ' ')               // 연속된 공백을 하나로
        ?.trim();                               // 앞뒤 공백 제거
    }
    return `&logFileId=${row.logFileId}&logHeaderId=${row.idex}&docType=${DocumentType.LogFax}&oriLogFileTitle=${sanitizeFileName(row.title)}`;
  }

  getListViewTitle() {
    return 'Fax Log List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.LogFax} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
}

export default FaxLogListView;